import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { withStyles } from '@mui/styles';
import React, { Component } from "react";
import * as styleGlobal from "../infra/styleGlobal";
import { TooltipCustom } from "../infra/styleGlobal";


export default class Combobox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      blocktootlip: false
    };
  }
  handleClose = () => {
    this.setState({ open: false })
  };

  handleOpen = () => {
    if (!this.state.blocktootlip)
      this.setState({ open: true });
  };
  render() {
    let props = this.props;
    let { lista = [], tooltip, style = {}, variant = "standard", value = "", className, disabled } = props;
    let disableFocusListener = tooltip ? false : true;
    let disableTouchListener = tooltip ? false : true;
    let disableHoverListener = tooltip ? false : true;
    return (
      <FormSelectField fullWidth style={{ marginTop: 5 }}>
        <InputLabel style={{ marginLeft: 10, marginTop: 2.5 }}>{props.titulo}</InputLabel>
        <TooltipCustom
          disableFocusListener={disableFocusListener}
          disableTouchListener={disableTouchListener}
          disableHoverListener={disableHoverListener}
          open={this.state.open}
          onClose={this.handleClose} onOpen={this.handleOpen}
          title={props.tooltip}  >
          <Select
            style={{ ...style, }}
            multiple={props.multiple ? true : false}
            variant={variant}
            className={className}
            value={value}
            disabled={disabled}
            onOpen={(event, value) => {
              if (tooltip) {
                this.setState({ blocktootlip: true })
                this.handleClose();
              }
            }}
            onClose={(event, value) => {
              if (tooltip) {
                this.setState({ blocktootlip: false })
              }
            }}
            onChange={(event, value) => {
              props.onChange(event.target.value);
            }}
            autoWidth
          >
            {lista.map((item, index) => {
              return (
                <MenuItem key={index + "a"} value={item._id}>{item.label} </MenuItem>
              );
            })}
          </Select>
        </TooltipCustom>
      </FormSelectField >
    )
  };
}

const FormSelectField = withStyles({
  root: {
    backgroundColor: styleGlobal.color8,
    '& .MuiInputLabel-root': {
      color: 'black !important'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: styleGlobal.color8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: styleGlobal.color8,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: styleGlobal.color8,
    },
  },
})(FormControl);

//neste dash é _id , e não id
let exemplo = [

  { _id: 1, label: "ativo" },
  { _id: 2, label: "desativado" }

]




/*

<Select
titulo={"Banco"}
value={this.state.recebimento && this.state.recebimento.banco ? this.state.recebimento.banco : ""}
lista={this.state.listBancos}
onChange={value => Util.handleChange(this, "objfiltro", "flag_desativada", value)}
onChange={(value) => {
  this.setState({
    recebimento: {
      ...this.state.recebimento,
      banco: event.target.value
    }
  });
}}
/>
*/
// export function getTimezones(select) {
//   var zones = [];
//   var v = "";
//   if (select) {
//     zones.push({ id: 'none', label: "Fuso Horário - Escolha" });
//   }
//   zones.push({ id: (v = "America/Araguaina"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Bahia"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Belem"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Boa_Vista"), label: v, offset: -4 });
//   zones.push({ id: (v = "America/Campo_Grande"), label: v, offset: -4 });
//   zones.push({ id: (v = "America/Cuiaba"), label: v, offset: -4 });
//   zones.push({ id: (v = "America/Eirunepe"), label: v, offset: -5 });
//   zones.push({ id: (v = "America/Fortaleza"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Maceio"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Manaus"), label: v, offset: -4 });
//   zones.push({ id: (v = "America/Noronha"), label: v, offset: -2 });
//   zones.push({ id: (v = "America/Porto_Velho"), label: v, offset: -4 });
//   zones.push({ id: (v = "America/Recife"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Rio_Branco"), label: v, offset: -5 });
//   zones.push({ id: (v = "America/Sao_Paulo"), label: v, offset: -3 });
//   zones.push({ id: (v = "America/Santarem"), label: v, offset: -4 });

//   return zones;
// }


/*

  list.forEach(item => {
        item._id = parseInt(item._id);
        item.label = item.nome;
      });

const Combobox = (props) => {

  let { lista = {} } = props;
  return (
    <FormControl fullWidth style={{ marginTop: 15 }}>
      <InputLabel>{props.titulo}</InputLabel>
      <Select
        value={props.value}
        onChange={(event, value) => {
          props.onChange(event.target.value);
        }}
        autoWidth
      >
        {lista.map((item) => {
          return (
            <MenuItem value={item.id}>{item.label} </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  )
}
*/
// Combobox;
